import PropTypes from "prop-types";

// material-ui
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  CardHeader,
  Divider,
  styled
} from "@mui/material";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import Paper from "@mui/material/Paper";

// project imports

// assets
import { useEffect, useState } from "react";
import { InternalApplicationService } from "../../../services/intranet-portal-services";
import { toast } from "react-toastify";
import CustomButton from "../../../ui-component/CustomUiComponent/Button";
import useIntranetPortalCoreApi from "../../../hooks/useIntranetPortalAdminApi";
import { runTimeConfig } from "@/config";

// const useStyles = makeStyles((theme: any) => ({
//   paper: {
//     backgroundColor: theme.palette.background.paper,
//     boxShadow: theme.shadows[5],
//     padding: theme.spacing(2, 4, 3, 2),
//   },
// }))

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
  minHeight: 100,
  padding: "1rem 0.5rem"
}));
// ==============================|| DASHBOARD - TOTAL INCOME LIGHT CARD ||============================== //

const ActiveAppCard = (): React.ReactElement => {
  const { handleRequest } = useIntranetPortalCoreApi();

  const [data, setData] = useState<any>();
  const [noOfActiveApp, setNoOfActiveApp] = useState<number>(8);

  // Get Internal Application Data
  const getInternalActiveAppData = async (): Promise<void> => {
    await handleRequest(() =>
      InternalApplicationService.getCoreApiApiAppInternalApplicationActiveInternalApplications()
    ).then((response) => {
      if (response != null) {
        setData(response);
      }
    });
  };

  const splicedActiveData = data?.items?.slice(0, noOfActiveApp);

  useEffect(() => {
    void getInternalActiveAppData();
  }, []);

  const handleSeeMore = (): void => {
    setNoOfActiveApp((prevValue) => prevValue * 2);
  };
  const handleSeeLess = (): void => {
    setNoOfActiveApp(4);
  };

  // HANDLE SORT
  const handleSort = async (
    srcId: string,
    desId: string,
    srcOrder: number,
    desOrder: number
  ): Promise<void> => {
    // try {
    const body = {
      id: [desId, srcId],
      orderNumber: [desOrder, srcOrder]
    };
    await handleRequest(() =>
      InternalApplicationService.postCoreApiApiAppInternalApplicationChangeInternalApplicationOrder(
        body
      )
    ).then(async (response) => {
      if (response != null) {
        toast.success("Sorted Successfully.");
        await getInternalActiveAppData();
      }
    });
    // } catch (error) {}
  };

  return (
    <>
      <Card sx={{ mb: "1rem" }} elevation={1}>
        <CardHeader title="Internal Applications" />
        <Divider />
        <CardContent>
          <DragDropContext
            onDragEnd={(param: any) => {
              const srcI = param?.source?.index;
              const desI = param?.destination?.index;

              if (desI !== undefined && srcI !== desI) {
                const srcOrder = data.items[srcI].orderNumber;
                const desOrder = data.items[desI].orderNumber;

                const srcId = data.items[srcI].id; // Source item ID
                const desId = data.items[desI].id; // Destination item ID

                data.items[srcI].orderNumber = desOrder;
                data.items[desI].orderNumber = srcOrder;

                void handleSort(srcId, desId, desOrder, srcOrder);
              }
            }}
          >
            <Grid container>
              <Droppable droppableId="droppable-1" direction="horizontal">
                {(provided) => (
                  <Grid container ref={provided.innerRef} {...provided.droppableProps} spacing={2}>
                    {splicedActiveData?.map((item: any, index: number) => {
                      return (
                        <Draggable
                          key={item?.id}
                          draggableId={"draggable-" + String(item?.id)}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <Grid
                              item
                              xs={6}
                              sm={4}
                              lg={3}
                              key={index}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <a
                                href={`${item.applicationUrl as string}`}
                                target="_blank"
                                style={{ textDecoration: "none" }}
                                rel="noreferrer"
                              >
                                <Box
                                  {...provided.dragHandleProps}
                                  sx={{ height: "100%" }}
                                  style={{ cursor: "grab" }}
                                >
                                  <Item elevation={2} sx={{ height: "100%" }}>
                                    <img
                                      width="80px"
                                      height="80px"
                                      src={`${
                                        runTimeConfig.VITE_BASE_URL
                                      }/core-api/internal-application-logos/file/${
                                        item.id as string
                                      }
                                            `}
                                      alt={"Image is not available"}
                                      style={{
                                        objectFit: "contain",
                                        objectPosition: "center"
                                      }}
                                    />
                                    <Typography color="black" variant="body1" textAlign="center">
                                      {item?.name}
                                    </Typography>
                                  </Item>
                                </Box>
                              </a>
                            </Grid>
                          )}
                        </Draggable>
                      );
                    })}
                  </Grid>
                )}
              </Droppable>

              {data?.items?.length > 4 && (
                <CustomButton
                  variant="contained"
                  color="error"
                  label={noOfActiveApp > data?.items?.length ? "See Less" : "See More"}
                  // variant={"contained"}
                  onClick={() => {
                    handleSeeMore();
                    if (noOfActiveApp > data?.items?.length) {
                      handleSeeLess();
                    }
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    marginTop: "1rem",
                    height: "100%"
                  }}
                />
              )}
            </Grid>
          </DragDropContext>
        </CardContent>
      </Card>
    </>
  );
};
ActiveAppCard.propTypes = {
  isLoading: PropTypes.bool
};

export default ActiveAppCard;
